// extracted by mini-css-extract-plugin
export default {"infoModal":"InfoModal_infoModal__+pKct","visible":"InfoModal_visible__SbmsQ","container":"InfoModal_container__LZXds","close":"InfoModal_close__B2EEN"};